import config from "../../config";
import { statusHandeling } from "../../statusHandeling";
import { consumeNextDispatchId } from "../../utils/dispatchTracking";
import { withOverageRetry } from "./usageOverage";

function dispatchHeader() {
  const id = consumeNextDispatchId();
  return id ? { "X-Dispatch-Id": id } : {};
}

function authHeader() {
  let user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    if (user.key) {
      return { Authorization: "Token  " + user.key };
    } else {
      return {};
    }
  } else {
    return {};
  }
}

const getMemberList = async (page) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/patient-list/?page=" + page + "&office_id=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getMemberList2 = async (page, treatmentFilters, tags) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  let searchQuery = "";

  if (treatmentFilters.name) {
    searchQuery += `&name=${treatmentFilters.name}`;
  }

  if (treatmentFilters.email) {
    searchQuery += `&email=${treatmentFilters.email}`;
  }

  if (treatmentFilters.phone) {
    searchQuery += `&phone=${treatmentFilters.phone}`;
  }

  if (treatmentFilters.not_completed_within_months && treatmentFilters.not_completed_procedure_ids && treatmentFilters.not_completed_procedure_ids.length > 0) {
    searchQuery += `&not_completed_within_months=${treatmentFilters.not_completed_within_months}&not_completed_procedure_code_ids=${treatmentFilters.not_completed_procedure_ids}`;
  }

  if (treatmentFilters.completed_within_months && treatmentFilters.completed_procedure_ids && treatmentFilters.completed_procedure_ids.length > 0) {
    searchQuery += `&completed_within_months=${treatmentFilters.completed_within_months}&completed_procedure_code_ids=${treatmentFilters.completed_procedure_ids}`;
  }

  if (treatmentFilters.planned_within_months && treatmentFilters.planned_procedure_ids && treatmentFilters.planned_procedure_ids.length > 0) {
    var plannedIds = treatmentFilters.planned_procedure_ids.includes("all") ? "all" : treatmentFilters.planned_procedure_ids.join(",");
    searchQuery += `&planned_within_months=${treatmentFilters.planned_within_months}&planned_procedure_code_ids=${plannedIds}`;
  }

  // Latest breakdown / estimate "after" a date, and appointment date range.
  if (treatmentFilters.latest_breakdown_after) {
    searchQuery += `&latest_breakdown_after=${treatmentFilters.latest_breakdown_after}`;
  }

  if (treatmentFilters.latest_estimate_after) {
    searchQuery += `&latest_estimate_after=${treatmentFilters.latest_estimate_after}`;
  }

  if (treatmentFilters.appointment_start && treatmentFilters.appointment_end) {
    searchQuery += `&appointment_start=${treatmentFilters.appointment_start}&appointment_end=${treatmentFilters.appointment_end}`;
  }

  // Newest-first date sort for the insurance work tabs (latest_breakdown /
  // latest_estimate / latest_activity) — the backend PatientList honors it.
  if (treatmentFilters.ordering) {
    searchQuery += `&ordering=${treatmentFilters.ordering}`;
  }

  if (tags.length > 0) {
    searchQuery += `&tags=${tags}`;
  }

  // During the guided onboarding tour, include the demo patient as the first row.
  if (localStorage.getItem("tourDemoActive") === "1") {
    searchQuery += "&include_tour_demo=1";
  }

  const req = new Request(
    config.apiGateway.URL + "/clinics/patient-list/?page=" + page + "&office_id=" + localStorage.getItem("selectedOffice") + searchQuery,
    {
      method: "GET",
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getData = async () => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/treatment-info/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const postNoteAndImage = async (formData, state) => {
  const myHeaders = {
    ...authHeader(),
  };

  const req = new Request(
    config.apiGateway.URL + "/clinics/doctor-note-lc/?office_id=" + localStorage.getItem("selectedOffice") + "&status=" + state,
    {
      method: "POST",
      headers: myHeaders,
      body: formData,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  return {
    json: json,
    status: response.status,
    message: response.message,
  };
};

const createTreatmentPlans = async (data) => {
  const { name, patient, tooth_from, priority, procedure, estimated_cost, insurance_coverage, discount } = data;
  const myHeaders = {
    "Content-Type": "application/json",
    ...authHeader(),
  };

  const stringifiedFields = JSON.stringify({
    name,
    patient,
    tooth_from,
    priority,
    discount,
    estimated_cost,
    insurance_coverage,
  });

  const requestBody = JSON.parse(stringifiedFields);
  requestBody.procedure = procedure;

  const response = await fetch(config.apiGateway.URL + "/clinics/create-first-treatment/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(requestBody),
  });
  const json = await response.json();
  return {
    json: json,
    status: response.status,
    message: "Success",
  };
};

const createTreatmentPlanAndProcedure = async (data) => {
  const { name, patient, tooth_from, treatment_procedure_data } = data;

  const myHeaders = {
    "Content-Type": "application/json",
    ...authHeader(),
  };

  const stringifiedFields = JSON.stringify({
    name,
    patient,
    tooth_from,
    treatment_procedure_data,
  });

  const requestBody = JSON.parse(stringifiedFields);
  requestBody.procedure = treatment_procedure_data.procedure_code;

  const response = await fetch(
    config.apiGateway.URL + "/clinics/create-treatment-and-procedure/?office_id=" + localStorage.getItem("selectedOffice"),
    {
      method: "POST",
      headers: myHeaders,
      body: JSON.stringify(requestBody),
    },
  );
  const json = await response.json();
  return {
    json: json,
    status: response.status,
    message: "Success",
  };
};

const createTreatmentPlans2 = async (data) => {
  const { name, patient, tooth_from, treatment_procedure_data } = data;

  const myHeaders = {
    "Content-Type": "application/json",
    ...authHeader(), // Assuming this is a custom authorization header function
  };

  const stringifiedFields = JSON.stringify({
    name,
    patient,
    tooth_from,
    treatment_procedure_data,
  });
  const requestBody = JSON.parse(stringifiedFields);

  const response = await fetch(config.apiGateway.URL + "/clinics/create-first-treatment/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(requestBody),
  });

  const json = await response.json();
  return {
    json: json,
    status: response.status,
    message: "Success",
  };
};

const createProcedures = async (data) => {
  const { procedure_code, treatment, tooth, discount, insurance_estimate, estimated_cost } = data;

  const myHeaders = {
    "Content-Type": "application/json",
    ...authHeader(), // Assuming this is a custom authorization header function
  };

  const stringifiedFields = JSON.stringify({
    procedure_code,
    treatment,
    tooth,
    discount,
    insurance_estimate,
    estimated_cost,
  });
  const requestBody = JSON.parse(stringifiedFields);

  const response = await fetch(config.apiGateway.URL + "/clinics/treatment-procedure-lc/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(requestBody),
  });

  const json = await response.json();
  return {
    json: json,
    status: response.status,
    message: "Success",
  };
};

const createEducational = async (formData) => {
  const myHeaders = {
    ...authHeader(), // Assuming this is a custom authorization header function
  };

  const response = await fetch(config.apiGateway.URL + "/clinics/video-file-lc/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "POST",
    headers: myHeaders, // Do not set Content-Type, as it's automatically set for FormData
    body: formData, // Directly pass the FormData object
  });

  const json = await response.json();
  return {
    json: json,
    status: response.status,
    message: "Success",
  };
};

const getTreatmentPlans = async (ApprovStatus, search, page, startDate, endDate, procedure) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL +
    "/clinics/list-treatment-by-patient/?office_id=" +
    localStorage.getItem("selectedOffice") +
    "&filtering=" +
    ApprovStatus +
    "&page=" +
    page +
    "&search=" +
    search +
    "&start_date=" +
    startDate +
    "&end_date=" +
    endDate +
    "&procedure=" +
    procedure,
    {
      method: "GET",
      headers: myHeaders,
    },
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getTreatmentPlans2 = async (ApprovStatus, search, page, startDate, endDate, procedure, id, pms) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL +
    "/clinics/list-treatment-by-patient/?office_id=" +
    localStorage.getItem("selectedOffice") +
    "&patient_id=" +
    id +
    "&filtering=" +
    ApprovStatus +
    "&page=" +
    page +
    "&search=" +
    search +
    "&start_date=" +
    startDate +
    "&end_date=" +
    endDate +
    "&procedure=" +
    procedure +
    "&pms_filtering=" +
    pms,
    {
      method: "GET",
      headers: myHeaders,
    },
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getEducatinal = async (page) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/video-file-lc/?office_id=" + localStorage.getItem("selectedOffice") + "&page=" + page, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getTreatmentModal = async (patient_id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL + "/clinics/list-treatment-by-patient/?office_id=" + localStorage.getItem("selectedOffice") + "&patient_id=" + patient_id,
    {
      method: "GET",
      headers: myHeaders,
    },
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getProceduresPms = async (patient_id, search = "", page = 1, type = "active") => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL +
    "/clinics/list-treatmentprocedure-by-patient/?office_id=" +
    localStorage.getItem("selectedOffice") +
    "&patient_id=" +
    patient_id +
    "&search=" +
    search +
    "&status=" +
    type,
    {
      method: "GET",
      headers: myHeaders,
    },
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getDoctorNote = async (patient_id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(
    config.apiGateway.URL + "/clinics/doctor-note-lc/?office_id=" + localStorage.getItem("selectedOffice") + "&patient_id=" + patient_id,
    {
      method: "GET",
      headers: myHeaders,
    },
  );
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const getEduByPatient = async (id) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(config.apiGateway.URL + "/clinics/treatment-rud/" + id + "/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const UpdateTreatmentPlans = async (id, data) => {
  const { description, priority, name, estimated_cost, insurance_coverage, tooth_from, discount } = data;
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const stringifiedFields = JSON.stringify({
    description,
    priority,
    name,
    estimated_cost,
    insurance_coverage,
    tooth_from,
    discount,
  });

  const requestBody = JSON.parse(stringifiedFields);
  requestBody.procedure = priority;
  const officeId = localStorage.getItem("selectedOffice");
  const req = new Request(`${config.apiGateway.URL}/clinics/treatment-rud/${id}/?office_id=${officeId}`, {
    body: JSON.stringify(requestBody),
    method: "PATCH",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const UpdateProcedures = async (id, data) => {
  const { procedure_code, treatment, tooth, estimated_cost, discount, insurance_estimate } = data;
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const stringifiedFields = JSON.stringify({
    procedure_code,
    treatment,
    tooth,
    discount,
    insurance_estimate,
    estimated_cost,
  });

  const requestBody = JSON.parse(stringifiedFields);
  const officeId = localStorage.getItem("selectedOffice");
  const req = new Request(`${config.apiGateway.URL}/clinics/treatment-procedure-rud/${id}/?office_id=${officeId}`, {
    body: JSON.stringify(requestBody),
    method: "PATCH",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const visibleTreatmentPlans = async (id, data) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const requestBody = JSON.stringify({
    visible_to_patient: data.visible_to_patient,
  });

  const officeId = localStorage.getItem("selectedOffice");
  const req = new Request(`${config.apiGateway.URL}/clinics/treatmentplan-rud/${id}/?office_id=${officeId}`, {
    body: requestBody,
    method: "PATCH",
    headers: myHeaders,
  });

  const response = await fetch(req);
  if (!response.ok) {
    throw new Error("Network response was not ok");
  }
  const json = await response.json();
  return json;
};

const RemoveTreatmentPlans = async (id) => {
  const myHeaders = Object.assign(authHeader());
  const url = `${config.apiGateway.URL}/clinics/treatment-rud/${id}/?office_id=${localStorage.getItem("selectedOffice")}`;

  const req = new Request(url, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  } else {
    const res = {
      json: { message: "succssfull" },
      status: 204,
      message: "Treatment plan deleted successfully",
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }
};

const RemoveProcedures = async (id) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url = config.apiGateway.URL + "/clinics/treatment-procedure-rud/" + id + "/" + "?office_id=" + localStorage.getItem("selectedOffice");

  const req = new Request(url, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  } else {
    const res = {
      json: { message: "succssfull" },
      status: 204,
      message: "Treatment plan deleted successfully",
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }
};

const removeImages = async (id) => {
  const myHeaders = Object.assign(authHeader());
  var url = "";
  url = config.apiGateway.URL + "/clinics/remove-image/" + id + "/" + "?office_id=" + localStorage.getItem("selectedOffice");

  const req = new Request(url, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  } else {
    const res = {
      json: { message: "succssfull" },
      status: 204,
      message: "Image deleted successfully",
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }
};

const getProcedure = async (page, search) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const searchObj = typeof search === "object" && search !== null ? search : {};

  const params = new URLSearchParams();
  params.set("page", String(page));
  params.set("office_id", localStorage.getItem("selectedOffice"));

  // Prefer a single `search` term: DRF SearchFilter uses icontains on procedure_code (and other
  // search_fields), so partial codes match stored values like "D0120". The old `procedure_code`
  // query param was django-filter exact match and failed when users typed digits only (e.g. "0120"
  // vs "D0120").
  if (Object.prototype.hasOwnProperty.call(searchObj, "query")) {
    const q = String(searchObj.query != null ? searchObj.query : "").trim();
    if (q) {
      params.set("search", q);
    }
  } else {
    const procedureCode = (searchObj.procedureCode || "").trim();
    const procedureDescription = (searchObj.procedureDescription || "").trim();
    const combined = [procedureCode, procedureDescription].filter(Boolean).join(" ").trim();
    if (combined) {
      params.set("search", combined);
    }
  }

  const url = `${config.apiGateway.URL}/clinics/procedure-code-lc/?${params.toString()}`;

  const req = new Request(url, {
    method: "GET",
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  const res = {
    json: json,
    status: response.status,
    message: response.message,
  };

  return res;
};

const UpdateDoctorNote = async (formData, id) => {
  const myHeaders = {
    ...authHeader(),
  };

  const req = new Request(config.apiGateway.URL + "/clinics/doctor-note-rud/" + id + "/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "PATCH",
    headers: myHeaders,
    body: formData,
  });

  const response = await fetch(req);
  const json = await response.json();
  return {
    json: json,
    status: response.status,
    message: response.message,
  };
};

const UpdateEducational = async (formData) => {
  const myHeaders = {
    ...authHeader(),
  };

  const req = new Request(config.apiGateway.URL + "/clinics/educational-content-lc/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "POST",
    headers: myHeaders,
    body: formData,
  });

  const response = await fetch(req);
  const json = await response.json();
  return {
    json: json,
    status: response.status,
    message: response.message,
  };
};

const postExistingPro = async (formData) => {
  const myHeaders = {
    ...authHeader(),
  };

  const req = new Request(config.apiGateway.URL + "/clinics/create-treatment-procedure/?office_id=" + localStorage.getItem("selectedOffice"), {
    method: "POST",
    headers: myHeaders,
    body: formData,
  });

  const response = await fetch(req);
  const json = await response.json();
  return {
    json: json,
    status: response.status,
    message: response.message,
  };
};

const UpdateEducational2 = async (id, formData) => {
  const myHeaders = {
    ...authHeader(),
  };

  const req = new Request(
    config.apiGateway.URL + "/clinics/educational-content-rud/" + id + "/?office_id=" + localStorage.getItem("selectedOffice"),
    {
      method: "PATCH",
      headers: myHeaders,
      body: formData,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  return {
    json: json,
    status: response.status,
    message: response.message,
  };
};

// This will create a new breakdown in cause breakdown id was null otherwise just add the created proceudre to the target breakdown
const addNewBreakdownProcedure = async (data) => {
  const myHeaders = { ...authHeader(), "Content-Type": "application/json" };

  const office_id = localStorage.getItem("selectedOffice");
  const req = new Request(config.apiGateway.URL + `/clinics/patient-procedure-coverage-crud/?office_id=${office_id}`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(data),
  });

  const response = await fetch(req);
  const json = await response.json();

  return {
    json: json,
    status: response.status,
    message: response.message,
  };
};

// For updating basic, major and ortho
const updateBreakdownItems = async (breakdownID, data) => {
  const myHeaders = { ...authHeader(), "Content-Type": "application/json" };

  const req = new Request(
    config.apiGateway.URL + `/clinics/breakdown-patient-rud/${breakdownID}/?office_id=${localStorage.getItem("selectedOffice")}`,
    {
      method: "PATCH",
      headers: myHeaders,
      body: JSON.stringify(data),
    },
  );

  const response = await fetch(req);
  const json = await response.json();

  return {
    json: json,
    status: response.status,
    message: response.message,
  };
};

const updateBreakdown = async (breakdownID, data) => {
  const myHeaders = { ...authHeader(), "Content-Type": "application/json" };

  const office_id = localStorage.getItem("selectedOffice");
  const req = new Request(config.apiGateway.URL + `/clinics/patient-procedure-coverage-crud/?office_id=${office_id}&breakdown_id=${breakdownID}`, {
    method: "PATCH",
    headers: myHeaders,
    body: JSON.stringify(data),
  });

  const response = await fetch(req);
  const json = await response.json();

  return {
    json: json,
    status: response.status,
    message: response.message,
  };
};

const deleteBreakdownProcedure = async (breakdownID, procedureID) => {
  const myHeaders = { ...authHeader(), "Content-Type": "application/json" };

  const office_id = localStorage.getItem("selectedOffice");
  const req = new Request(config.apiGateway.URL + `/clinics/patient-procedure-coverage-crud/?office_id=${office_id}&breakdown_id=${breakdownID}`, {
    method: "DELETE",
    headers: myHeaders,
    body: JSON.stringify({ id: procedureID }),
  });

  const response = await fetch(req);

  if (response.status > 250) {
    const json = await response.json();
    const res = {
      json: json,
      status: response.status,
      message: response.message,
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  } else {
    const res = {
      json: { message: "succssfull" },
      status: 204,
      message: "Treatment plan deleted successfully",
    };

    statusHandeling.statusCodeHandeling(res.status);
    return res;
  }
};

const recalculateBreakdown = async (policyID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  // const req = new Request(`${config.apiGateway.URL}/clinics/breakdown-calculate-coverage/?breakdown_id=${breakdownID}`, {
  // const req = new Request(`${config.apiGateway.URL}/clinics/breakdown-patient-coverage/?patient_id=${patientID}`, {
  const req = new Request(`${config.apiGateway.URL}/clinics/breakdown-calculate-coverage/?policy_id=${policyID}`, {
    headers: myHeaders,
    method: "POST",
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// Set/replace the SELECTED breakdown's manual per-category card overrides.
// Pass the full merged object ({} clears all). Reuses the breakdown RUD endpoint.
const updateBreakdownCategoryOverrides = async (breakdownId, categoryOverrides) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(
    `${config.apiGateway.URL}/clinics/breakdown-patient-rud/${breakdownId}/?office_id=${localStorage.getItem("selectedOffice")}`,
    {
      headers: myHeaders,
      method: "PATCH",
      body: JSON.stringify({ category_overrides: categoryOverrides }),
    }
  );
  const response = await fetch(req);
  const json = await response.json();
  return { json, status: response.status, message: response.message };
};

const getBreakdownCoverageAndProcedureCoveragesByPolicy = async (policyID, breakdownId) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  let url = `${config.apiGateway.URL}/clinics/get-policy-coverage/?policy_id=${policyID}`;
  if (breakdownId !== undefined && breakdownId !== null) url += `&breakdown_id=${breakdownId}`;
  const req = new Request(url, {
    method: "POST",
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// Insurance breakdowns uploading files
const uploadTreatmentBreakdowns = async (formData) => {
  const myHeaders = Object.assign(authHeader());

  formData.append("office_id", localStorage.getItem("selectedOffice"));

  const req = new Request(`${config.apiGateway.URL}/clinics/upload-pdf-breakdown-file/?office_id=${localStorage.getItem("selectedOffice")}`, {
    method: "POST",
    headers: myHeaders,
    body: formData,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// Eligibility - step 1
// INFO: This check if the required fields to continuing the flow are stored in the patient or not
const checkPatientInsuranceInfo = async (patientID) => {
  const myHeaders = Object.assign(authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/patient/insurance/check?patient_id=${patientID}`, {
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// Eligibility - step 2
// INFO: If any of the field required to continue is not provided then set them throught this
const setPatientInsuranceInfo = async (patientID, insurnaceInfo) => {
  const myHeaders = Object.assign({ "content-type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/patient/insurance/set?patient_id=${patientID}`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(insurnaceInfo),
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// Eligibility - step 3
// INFO: If any of the field required to continue is not provided then set them throught this, This will return two token, a `task_id` token and a `token`
const patientAction = async (policyID, options = {}) => {
  const myHeaders = Object.assign({ "content-type": "application/json" }, authHeader(), dispatchHeader());
  const { isForBreakdown, insuranceBreakdownId } = options;
  let qs = `policy_id=${policyID}&use_apify=false`;
  if (isForBreakdown && insuranceBreakdownId != null) {
    qs += `&is_for_breakdown=true&insurance_breakdown_id=${encodeURIComponent(insuranceBreakdownId)}`;
  }
  const req = new Request(`${config.apiGateway.URL}/clinics/patient-action-view/?${qs}`, {
    method: "POST",
    headers: myHeaders,
    // body: JSON.stringify({}),
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// Eligibility - step 4
// INFO: Checks the status of the task using `task_id`
const checkTaskStatus = async (taskID) => {
  const myHeaders = Object.assign({ "content-type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/patient/eligibility-task-status/?task_id=${taskID}`, {
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// Eligibility - step 5
// INFO: Checks if the agent asked for 2fa using `token`, if the status was `waitin` we need to proved the 2fa to continue but if it was `done` we are good to go
const chekcAgentStatusFor2FA = async (token) => {
  const myHeaders = Object.assign({ "content-type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/two-fa-input/?token=${token}`, {
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// Eligibility - step 6
// INFO: Provide the required 2fa, so the agent can continue
const setEligibilityAgent2FA = async (authData) => {
  const myHeaders = Object.assign({ "content-type": "application/json" }, authHeader(), dispatchHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/two-fa-input/`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(authData),
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// Step 7 - Agents
// Eligibility agnet
// INFO: Get the eligbility data
const getEligibiltyData = async (patientID) => {
  const myHeaders = Object.assign(authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/patient/eligibility-status?patient_id=${patientID}`, {
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json: json, status: response.status, message: response.message };

  return res;
};

// Breakdown agent
// INFO: Start the breakdown agent
// INFO: The breakdown agent is almost the same as eligbility, checks for policy info, asks for policy info (if wasn't provided), checks for 2fa, asks for 2fa
const startBreakdownAgent = async (policyID) => {
  // Capture the dispatch id once so the original + any overage-confirm retry
  // share the same X-Dispatch-Id (idempotency).
  const dh = dispatchHeader();
  return withOverageRetry(async (confirmOverage) => {
    const myHeaders = Object.assign({}, authHeader(), dh);
    if (confirmOverage) myHeaders["X-Confirm-Overage"] = "1";
    const req = new Request(`${config.apiGateway.URL}/clinics/patient/scraper-breakdown/?policy_id=${policyID}&use_apify=false`, {
      headers: myHeaders,
      method: "POST",
    });

    const response = await fetch(req);
    const json = await response.json();
    return { json: json, status: response.status, message: response.message };
  });
};

// AI phone-call breakdown (voice-agent service). Same 402-overage handshake
// as the scraper dispatches; results flow back through the normal ScrapeJob
// status pipeline (drawer/toasts/failure card) and the breakdown list.
const startPhoneBreakdownCall = async (policyID) => {
  const dh = dispatchHeader();
  return withOverageRetry(async (confirmOverage) => {
    const myHeaders = Object.assign({}, authHeader(), dh, { "Content-Type": "application/json" });
    if (confirmOverage) myHeaders["X-Confirm-Overage"] = "1";
    const req = new Request(`${config.apiGateway.URL}/clinics/initiate-insurance-call/`, {
      headers: myHeaders,
      method: "POST",
      body: JSON.stringify({ policy_id: policyID }),
    });

    const response = await fetch(req);
    const json = await response.json();
    return { json: json, status: response.status, message: response.message };
  });
};

// Predetermination agent
// INFO: Start the breakdown agent
// INFO: The breakdown agent is almost the same as eligbility, checks for policy info, asks for policy info (if wasn't provided), checks for 2fa, asks for 2fa
// `providerIds` (optional array of Provider ids) fans the estimate fetch out
// across the selected provider accounts — one scrape per account, since a
// predetermination only appears under the submitting provider's account. Empty
// → the office default account (unchanged behavior). Sent as a JSON string
// because FormData can't carry a list cleanly to DRF.
const startPredeterminationAgent = async (policyID, providerIds = []) => {
  const dh = dispatchHeader();
  return withOverageRetry(async (confirmOverage) => {
    const requestData = new FormData();
    // requestData.set("patient_id", patientID);
    requestData.set("policy_id", policyID);
    requestData.set("statement_type", "PDT");
    requestData.set("use_apify", false);
    requestData.set("office_id", localStorage.getItem("selectedOffice"));
    if (Array.isArray(providerIds) && providerIds.length) {
      requestData.set("provider_ids", JSON.stringify(providerIds));
    }
    if (confirmOverage) requestData.set("confirm_overage", "true");

    const myHeaders = Object.assign({}, authHeader(), dh);
    if (confirmOverage) myHeaders["X-Confirm-Overage"] = "1";
    const req = new Request(`${config.apiGateway.URL}/clinics/scrape-insurance-estimate`, {
      headers: myHeaders,
      method: "POST",
      body: requestData,
    });

    const response = await fetch(req);
    const json = await response.json();
    return { json: json, status: response.status, message: response.message };
  });
};

// Eligibility - step 8
// INFO: Get breakdown data based on the patient id
// INFO: This take the last patient breakdown data using the patient id. Here i used patient id cause if we run the agent without uploading
// INFO: a file or creating the first procedure (policy item), then we don't have any breakdown id to get the breakdown data.
const getBreakdownDetailByPatient = async (patientID) => {
  const myHeaders = Object.assign(authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/breakdown-patient-details-by-pid/?patient_id=${patientID}`, {
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

// Call agent
const triggerCallAgent = async (patientID, promptType = undefined) => {
  const myHeaders = Object.assign(authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/make-call/?patient_id=${patientID}&prompt_type=${promptType || "instruction"}`, {
    headers: myHeaders,
    method: "POST",
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

// Requiring action
const getRequiringActions = async (type, page, tags = [], sort, treatmentFilters, arFilter) => {
  const myHeaders = Object.assign(authHeader());

  let queryParams = "";

  if (tags.length > 0) {
    queryParams += `&tags=${tags}`;
  }

  if (arFilter.length > 0) {
    queryParams += `&filters=${arFilter}`;
  }

  if (treatmentFilters.name) {
    queryParams += `&name=${treatmentFilters.name}`;
  }

  if (treatmentFilters.email) {
    queryParams += `&email=${treatmentFilters.email}`;
  }

  if (treatmentFilters.phone) {
    queryParams += `&phone=${treatmentFilters.phone}`;
  }

  const req = new Request(
    `${config.apiGateway.URL
    }/clinics/patients/requiring-action/?type=${type}&page=${page}${queryParams}&sort_days=${sort}&office_id=${localStorage.getItem(
      "selectedOffice",
    )}`,
    {
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

// Card for patients
const getCaredForPatients = async (page, tags = [], sort, treatmentFilters) => {
  const myHeaders = Object.assign(authHeader());

  let queryParams = "";

  if (tags.length > 0) {
    queryParams += `&tags=${tags}`;
  }

  if (treatmentFilters.name) {
    queryParams += `&name=${treatmentFilters.name}`;
  }

  if (treatmentFilters.email) {
    queryParams += `&email=${treatmentFilters.email}`;
  }

  if (treatmentFilters.phone) {
    queryParams += `&phone=${treatmentFilters.phone}`;
  }

  const req = new Request(
    `${config.apiGateway.URL}/clinics/patients/treatment-cared-for/?page=${page}${queryParams}&sort_days=${sort}&office_id=${localStorage.getItem(
      "selectedOffice",
    )}`,
    {
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const getPastAppointmentPatients = async (page, tags = [], sort, treatmentFilters) => {
  const myHeaders = Object.assign(authHeader());

  let queryParams = "";

  if (tags.length > 0) {
    queryParams += `&tags=${tags}`;
  }

  if (treatmentFilters.name) {
    queryParams += `&name=${treatmentFilters.name}`;
  }

  if (treatmentFilters.email) {
    queryParams += `&email=${treatmentFilters.email}`;
  }

  if (treatmentFilters.phone) {
    queryParams += `&phone=${treatmentFilters.phone}`;
  }

  const req = new Request(
    `${config.apiGateway.URL}/clinics/patients/treatment-overdue/?page=${page}${queryParams}&sort_days=${sort}&office_id=${localStorage.getItem(
      "selectedOffice",
    )}`,
    {
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const getTodayPatients = async (page, tags = [], sort, treatmentFilters, range = null) => {
  const myHeaders = Object.assign(authHeader());

  let queryParams = "";

  if (tags.length > 0) {
    queryParams += `&tags=${tags}`;
  }

  if (treatmentFilters.name) {
    queryParams += `&name=${treatmentFilters.name}`;
  }

  if (treatmentFilters.email) {
    queryParams += `&email=${treatmentFilters.email}`;
  }

  if (treatmentFilters.phone) {
    queryParams += `&phone=${treatmentFilters.phone}`;
  }

  if (range && typeof range.startDays === "number" && typeof range.endDays === "number") {
    queryParams += `&start_days=${range.startDays}&end_days=${range.endDays}`;
  }

  const req = new Request(
    `${config.apiGateway.URL}/clinics/today-patients/?page=${page}${queryParams}&sort_days=${sort}&office_id=${localStorage.getItem(
      "selectedOffice",
    )}`,
    {
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const getARHandled = async (page, tags = [], arFilter, treatmentFilters) => {
  const myHeaders = Object.assign(authHeader());

  let queryParams = "";
  if (tags.length > 0) {
    queryParams += `&tags=${tags}`;
  }

  if (arFilter.length > 0) {
    queryParams += `&filters=${arFilter}`;
  }

  if (treatmentFilters.name) {
    queryParams += `&name=${treatmentFilters.name}`;
  }

  if (treatmentFilters.email) {
    queryParams += `&email=${treatmentFilters.email}`;
  }

  if (treatmentFilters.phone) {
    queryParams += `&phone=${treatmentFilters.phone}`;
  }

  const req = new Request(
    `${config.apiGateway.URL}/clinics/handled-ar/?page=${page}${queryParams}&office_id=${localStorage.getItem("selectedOffice")}`,
    {
      headers: myHeaders,
    },
  );

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const getAllTags = async () => {
  const myHeaders = Object.assign(authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/tags/?office_id=${localStorage.getItem("selectedOffice")}`, {
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const createTag = async (name) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/tags/?office_id=${localStorage.getItem("selectedOffice")}`, {
    method: "POST",
    body: JSON.stringify({ office_id: localStorage.getItem("selectedOffice"), name }),
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

const removeTag = async (tagID) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/tags/${tagID}/`, {
    method: "DELETE",
    headers: myHeaders,
  });

  const response = await fetch(req);

  let res;
  if (response.status > 250) {
    const json = await response.json();
    res = {
      json: json,
      status: response.status,
      message: response.message,
    };

    statusHandeling.statusCodeHandeling(res.status);
  } else {
    res = {
      json: { message: "succssfull" },
      status: 204,
      message: "Image deleted successfully",
    };
  }

  return res;
};

const reorderTags = async (orderedIds) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const req = new Request(`${config.apiGateway.URL}/clinics/tags/reorder/`, {
    method: "POST",
    body: JSON.stringify({ office_id: localStorage.getItem("selectedOffice"), ordered_ids: orderedIds }),
    headers: myHeaders,
  });

  const response = await fetch(req);
  const json = await response.json();
  const res = { json, status: response.status, message: response.message };

  return res;
};

// `manualAttentionNote` is only persisted server-side when this call is the
// one that ADDS the office's "Details Needed by Smilepass" tag to the patient (the
// backend diffs the incoming list against the patient's current tags). On a
// removal of that tag the note is cleared regardless of what's passed.
const setTagsForPatient = async (patientID, tags, manualAttentionNote) => {
  return withOverageRetry(async (confirmOverage) => {
    const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
    if (confirmOverage) myHeaders["X-Confirm-Overage"] = "1";
    const body = { staging_group_ids: tags };
    if (manualAttentionNote !== undefined) {
      body.manual_attention_note = manualAttentionNote;
    }
    if (confirmOverage) body.confirm_overage = true;
    const req = new Request(`${config.apiGateway.URL}/clinics/add-patient-tags/${patientID}/?office_id=${localStorage.getItem("selectedOffice")}`, {
      method: "PATCH",
      body: JSON.stringify(body),
      headers: myHeaders,
    });

    const response = await fetch(req);
    const json = await response.json();
    return { json, status: response.status, message: response.message };
  });
};

// Mark ONE policy's verification request fulfilled (the FTC "Mark Verified"
// action). Closes the per-policy request so the FTC row drops that policy (and
// the whole patient once the last policy is done); the server applies the
// terminal tag + meters the fulfillment. Returns the patient's resulting tags.
// `result`: "verified" (Mark Verified, the default) or "unavailable" — a
// breakdown our team could not obtain; closes the request with the note.
const fulfillVerificationRequest = async (patientID, policyId, requestType, note, result) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const body = { patient_id: patientID, policy_id: policyId, request_type: requestType };
  if (note !== undefined) body.note = note;
  if (result) body.result = result;
  const req = new Request(`${config.apiGateway.URL}/clinics/insurance-verification-requests/fulfill/?office_id=${localStorage.getItem("selectedOffice")}`, {
    method: "POST",
    body: JSON.stringify(body),
    headers: myHeaders,
  });
  const response = await fetch(req);
  const json = await response.json();
  return { json, status: response.status, message: response.message };
};

export const controller = {
  getTreatmentPlans,
  createTreatmentPlans,
  createTreatmentPlans2,
  UpdateTreatmentPlans,
  RemoveTreatmentPlans,
  visibleTreatmentPlans,
  getDoctorNote,
  UpdateDoctorNote,
  getProcedure,
  postNoteAndImage,
  getMemberList,
  getTreatmentModal,
  removeImages,
  createProcedures,
  getEducatinal,
  createEducational,
  RemoveProcedures,
  UpdateEducational,
  getTreatmentPlans2,
  getEduByPatient,
  UpdateEducational2,
  UpdateProcedures,
  getMemberList2,
  getData,
  getProceduresPms,
  postExistingPro,
  createTreatmentPlanAndProcedure,

  // Breakdowns
  getBreakdownCoverageAndProcedureCoveragesByPolicy,
  updateBreakdownCategoryOverrides,
  addNewBreakdownProcedure,
  updateBreakdown,
  recalculateBreakdown,
  updateBreakdownItems,
  uploadTreatmentBreakdowns,
  deleteBreakdownProcedure,

  // Eligbility agnet
  checkPatientInsuranceInfo,
  setPatientInsuranceInfo,
  patientAction,
  checkTaskStatus,
  chekcAgentStatusFor2FA,
  setEligibilityAgent2FA,
  getEligibiltyData,

  // Breakdonw agent
  startBreakdownAgent,
  startPhoneBreakdownCall,
  getBreakdownDetailByPatient,

  // Predetermination agnet
  startPredeterminationAgent,

  // Call agent
  triggerCallAgent,

  // Getting patients based on tab filter
  getRequiringActions,
  getCaredForPatients,
  getPastAppointmentPatients,
  getARHandled,
  getTodayPatients,

  // Tags
  getAllTags,
  fulfillVerificationRequest,
  createTag,
  removeTag,
  reorderTags,
  setTagsForPatient,
};

export const getPolicyBreakdowns = async (policyId, patientId) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/clinics/policy-breakdowns/?policy_id=${policyId}&patient_id=${patientId}`, {
    method: "GET",
    headers: myHeaders,
  });

  const response = await fetch(req);
  return {
    status: response.status,
    json: await response.json(),
  };
};

export const setPolicyDefaultBreakdown = async (policyId, breakdownId, patientId) => {
  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const req = new Request(`${config.apiGateway.URL}/clinics/policy-set-default-breakdown/`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify({
      policy_id: policyId,
      breakdown_id: breakdownId,
      patient_id: patientId,
    }),
  });

  const response = await fetch(req);
  return {
    status: response.status,
    json: await response.json(),
  };
};

// The Add Manually wizard: what to ask (codes, the last breakdown, PMS dates,
// group plan facts), before anything is created.
export const getManualBreakdownCodes = async (policyId) => {
  const req = new Request(`${config.apiGateway.URL}/clinics/breakdown-manual-codes/?policy_id=${policyId}`, {
    method: "GET",
    headers: Object.assign({ "Content-Type": "application/json" }, authHeader()),
  });
  const response = await fetch(req);
  return { status: response.status, json: await response.json() };
};

// The wizard's one save: the breakdown and every line, in one transaction.
export const createManualBreakdownWithLines = async (patientId, policyId, lines) => {
  const req = new Request(`${config.apiGateway.URL}/clinics/breakdown-manual-create/`, {
    method: "POST",
    headers: Object.assign({ "Content-Type": "application/json" }, authHeader()),
    body: JSON.stringify({ patient_id: patientId, policy_id: policyId, lines }),
  });
  const response = await fetch(req);
  return { status: response.status, json: await response.json() };
};

export const createManualBreakdown = async (patientId, policyId, patient, explicitOfficeId) => {
  let finalOfficeId = explicitOfficeId;
  if (!finalOfficeId && patient) {
    finalOfficeId = patient.office_id || (patient.office && patient.office.id);
  }
  if (!finalOfficeId) {
    finalOfficeId = localStorage.getItem("selectedOffice") || undefined;
  }

  const myHeaders = Object.assign({ "Content-Type": "application/json" }, authHeader());

  const body = {
    patient_id: patientId,
    policy_id: policyId,
  };
  if (finalOfficeId) {
    body.office_id = finalOfficeId;
  }

  const req = new Request(`${config.apiGateway.URL}/clinics/breakdown-manual-create/`, {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(body),
  });

  const response = await fetch(req);
  return {
    status: response.status,
    json: await response.json(),
  };
};
